document.addEventListener('DOMContentLoaded', () => {
	const section = document.querySelector('.meet-the-team')
	const slider = section.querySelector('.keen-slider')
	const before = section.querySelector('.before')
	const after = section.querySelector('.after')
	const numSlides = slider.querySelectorAll('.keen-slider__slide').length;
	console.log(numSlides);

	if (numSlides > 1) {
		var carousel = new KeenSlider(slider, {
			slides: {
				perView: 1.15,
				spacing: 24,
			},
			breakpoints: {
				'(min-width: 512px)': {
					slides: {
						perView: 1.8,
						spacing: 24,
					},
				},
				'(min-width: 768px)': {
					disabled: (numSlides <= 2) ? true : false,
					slides: {
						perView: 2.2,
						spacing: 32,
					},
				},
				'(min-width: 1200px)': {
					disabled: (numSlides <= 3) ? true : false,
					slides: {
						perView: 3.2,
						spacing: 32,
					},
				},
				'(min-width: 1536px)': {
					disabled: (numSlides <= 4) ? true : false,
					slides: {
						perView: 4.2,
						spacing: 32,
					},
				},
			},
		})

		before.addEventListener('click', () => {
			carousel.prev()
		})

		after.addEventListener('click', () => {
			carousel.next()
		})
	}
})
